import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { IoMdArrowDropright } from "react-icons/io";
import ConfirmationModal from "../../../components/Staff/Modals/ConfirmationModal";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TableRowSkeleton = () => (
  <tr className="border-gray-300 border-b">
    {[...Array(6)].map((_, index) => (
      <td key={index} className="border-[#dbdbdb] p-2 border-r text-center">
        <Skeleton width={index === 0 ? 30 : 80} />
      </td>
    ))}
  </tr>
);

const TableHeaderSkeleton = () => (
  <tr>
    {[...Array(6)].map((_, index) => (
      <th
        key={index}
        className="p-3 border-r font-medium text-[13px] text-center whitespace-nowrap"
      >
        <Skeleton width={index === 0 ? 30 : 80} />
      </th>
    ))}
  </tr>
);

const PaginationSkeleton = () => (
  <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md">
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={60} />
    </div>
    <div className="pt-2 pb-[8px] px-3">
      <Skeleton width={20} />
    </div>
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={40} />
    </div>
  </div>
);

const Edit_Task_Status = () => {
  let subtitle;
  const { baseUrl, openToast, staffs } = useGlobalContext();
  const [openIndex, setOpenIndex] = useState(null);
  const [status, setStatus] = useState([]);
  const [taskStatus, setTaskStatus] = useState([]);
  const [statusName, setStatusName] = useState();
  const [statusColor, setStatusColor] = useState();
  const [statusOrder, setStatusOrder] = useState();
  const [canBeChanged, setCanBeChanged] = useState([]);
  const [updateStatusName, setUpdateStatusName] = useState();
  const [updateStatusColor, setUpdateStatusColor] = useState();
  const [updateStatusOrder, setUpdateStatusOrder] = useState();
  const [updateCanBeChanged, setUpdateCanBeChanged] = useState([]);
  const [updateIsHiddenFor, setUpdateIsHiddenFor] = useState([]);
  const [taskData, setTaskData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const customStyles = {
    control: (provided) => ({}),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({}),
  };

  const [open11, setOpen11] = useState(false);
  // const [open101, setOpen101] = useState(false);
  console.log(open11);
  const onOpenModal11 = () => setOpen11(true);
  const onCloseModal11 = () => setOpen11(false);

  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  //salary dropdown
  const [isOpen1, setIsOpen1] = useState(false);

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const [isOn, setIsOn] = useState(false);

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  async function getAllTaskStatus() {
    try {
      setIsLoading(true);
      const result = await fetch(baseUrl + "task/status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status === 200) {
        const data = await result.json();
        console.log(data);
        setStatus(data?.taskStatus);
      }
    } catch (error) {
      console.log("some error occured", error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAllTaskStatus();
  }, []);

  // getAllTaskStatus();

  async function submitTaskStatus() {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "task/status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          taskStatusName: statusName,
          statusColor: statusColor || "black",
          statusOrder: Number(statusOrder),
          isHiddenFor: taskStatus.map((item) => item.value),
          canBeChangedId: canBeChanged.map((item) => item.value),
        }),
      });
      if (result.status === 201) {
        setIsLoading(false);
        openToast("Create Task Status Successfully", "success");
        getAllTaskStatus();
        setIsOpen(false);
        setStatusName("");
        setStatusColor("");
        setStatusOrder("");
        setTaskStatus([]);
        setCanBeChanged([]);
      }
    } catch (error) {
      console.log("some error occured", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function updateTaskStatus() {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "task/status/" + taskData.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          taskStatusName: updateStatusName,
          statusColor: updateStatusColor,
          statusOrder: Number(updateStatusOrder),
          isHiddenFor: updateIsHiddenFor,
          canBeChangedId: updateCanBeChanged,
        }),
      });
      if (result.status === 200) {
        setIsLoading(false);
        openToast("Task Status Updated Successfully", "success");
        setTaskData(null);
        getAllTaskStatus();
      }
    } catch (error) {
      console.log("some error occured", error);
    } finally {
      setIsLoading(false);
    }
  }
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };
  const exportCSV = () => {
    const csvData = projectPriorityDetail
      .map(
        (dep) =>
          `${dep?.Priority_name}, ${dep?.Priority_color}, ${dep?.Priority_order}`
      )
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "ProjectStatus.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("AllTaskStatus", 20, 10);
    projectPriorityDetail.forEach((dep, index) => {
      doc.text(
        `${index + 1}. ${dep.Priority_name},${dep.project_color},${
          dep.Priority_order
        }`,
        10,
        20 + index * 10
      );
    });
    doc.save("ProjectStatus.pdf");
  };

  const deleteTaskStatus = async (id) => {
    try {
      const result = await fetch(baseUrl + "task/status/" + id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status === 200) {
        openToast("Task Status Deleted Successfully", "success");
        getAllTaskStatus();
        onCloseModal11();
      }
    } catch (error) {
      console.log("some error occured", error);
    }
  };
  async function fetchProjectPriority() {
    try {
      const result = await fetch(baseUrl + "project-Priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status === 200) {
        const data = await result.json();
        setProjectPriorityDetail(data?.data);
      } else {
        const data = await result.json();
        console.error(data.message || "An unexpected error occured");
        setProjectPriorityDetail([]);
      }
    } catch (error) {
      console.log("some error occured", error);
    }
  }
  const [projectPriorityDetail, setProjectPriorityDetail] = useState();

  const printDepartments = () => {
    const printContent = projectPriorityDetail
      .map(
        (dep) =>
          `${dep.Priority_name},${dep.Priority_color}, ${dep.Priority_order} (Total Users: 1)`
      )
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(<pre>{printContent}</pre>);
    newWindow.document.close();
    newWindow.print();
  };

  const [rowsToShow, setRowsToShow] = useState(25);
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };
  const [exportFormat, setExportFormat] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the modal
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  //Modal2
  // State to control the visibility of the modal
  const [isOpen3, setIsOpen3] = useState(false);

  // Function to toggle the modal
  const toggleModal3 = () => {
    setIsOpen3(!isOpen3);
  };

  //Modal2

  const [isOpen5, setIsOpen5] = useState(true);

  // Toggle the visibility of tbody
  const toggleTable = () => {
    setIsOpen5(!isOpen5);
  };
  // Array of accordion items
  const [modalIsOpen6, setIsOpen6] = React.useState(false);
  function openModal6() {
    setIsOpen6(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  useEffect(() => {
    if (taskData) {
      setUpdateStatusName(taskData.taskStatusName);
      setUpdateStatusColor(taskData.statusColor);
      setUpdateStatusOrder(taskData.statusOrder);
      setUpdateIsHiddenFor(taskData?.isHiddenFor.map((item) => item.id));
      setUpdateCanBeChanged(taskData.TaskStatus.map((item) => item.id));
    }
  }, [taskData]);
  function closeModal6() {
    setIsOpen6(false);
  }
  return (
    <div className="w-full">
      <div className="bg-[#fff] p-[10px]">
        <div className="shadow-cs p-[20px] rounded-lg w-full">
          <div className="flex items-center gap-[14px] mb-[10px]">
            <div className="flex justify-center items-center h-[50px] text-[14px]">
              {/* Button to open the modal */}
              <button onClick={toggleModal} className="second-btn">
                Add Task Status
              </button>

              {isOpen && (
                <div className="z-[11] fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
                  <div className="bg-white shadow-lg rounded-lg w-96">
                    <div className="px-4 py-2 border-b">
                      <h2 className="font-semibold text-lg">
                        Create new task status
                      </h2>
                    </div>
                    <div className="p-4">
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Status Name</label>
                        <br />
                        <input
                          type="text"
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                          onChange={(e) => {
                            setStatusName(e.target.value);
                          }}
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Status Color</label>
                        <br />
                        <input
                          type="color"
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                          onChange={(e) => {
                            setStatusColor(e.target.value);
                          }}
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Status Order</label>
                        <br />
                        <input
                          type="text"
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                          onChange={(e) => {
                            setStatusOrder(e.target.value);
                          }}
                        />
                      </div>
                      {/* <div className="flex items-center gap-[6px] mb-[10px]">
                        <input type="checkbox" />
                        <p>Default Filter</p>
                      </div> */}
                      <div className="mb-[26px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">is hidden for</label>

                        <br />

                        <Select
                          isMulti
                          name="isHiddenFor"
                          options={staffs?.map(({ staffDetails, name }) => ({
                            label: name,
                            value: staffDetails?.id,
                          }))}
                          className="basic-multi-select newsetup3"
                          classNamePrefix="select"
                          value={taskStatus}
                          onChange={(selectedOptions) =>
                            setTaskStatus((prev) => [...selectedOptions])
                          }
                          styles={customStyles}
                        />
                      </div>
                      <div className="mb-[20px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">Can be changed to</label>
                        <br />
                        <Select
                          isMulti
                          name="canBeChanged"
                          classNamePrefix="select newsetup3"
                          onChange={(e) => {
                            setCanBeChanged(e);
                          }}
                          options={
                            status
                              ? status?.map((taskStatus, index) => {
                                  return {
                                    value: taskStatus.id,
                                    label: taskStatus.taskStatusName,
                                  };
                                })
                              : []
                          }
                          styles={customStyles}
                        >
                          {/* <option >Nothing Selected</option> */}
                        </Select>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-end gap-[10px] px-4 py-2 border-t">
                      <button onClick={toggleModal} className="first-btn">
                        Cancel
                      </button>
                      <button
                        onClick={() => submitTaskStatus()}
                        className={`${
                          isLoading ? "second-btn-disabled" : "second-btn"
                        }`}
                        disabled={isLoading}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start gap-[10px] mb-[14px]">
            <div className="flex items-center gap-[10px]">
              <div className="inline-block relative text-left">
                {/* Button to open/close the dropdown */}
                <select
                  onChange={handleSelectChange}
                  className="border-[#e5e7eb] shadow-sm mr-2 p-[7px] pr-3 border rounded-md text-[14px] focus:outline-none"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="120">120</option>
                </select>

                {/* Dropdown menu */}
                {isOpen1 && (
                  <div className="right-0 left-[0px] z-10 absolute border-gray-200 bg-white shadow-lg mt-2 border rounded-md w-[100%] origin-top-right">
                    <div
                      className=""
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        30
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        40
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        50
                      </a>
                    </div>
                  </div>
                )}
              </div>

              <select
                onChange={(e) => setExportFormat(e.target.value)}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md text-[14px] text-sm focus:outline-none"
              >
                <option value="CSV">CSV</option>
                <option value="PDF">PDF</option>
                <option value="Print">Print</option>
              </select>
              <button onClick={handleExport} className="second-btn">
                Export
              </button>
            </div>
            <div className="relative w-full md:w-[200px] lg:w-[200px] xl:w-[200px]">
              <input
                className="p-[6px] pr-[25px] summary-border rounded-2xl w-full text-[13px]"
                type="text"
                placeholder=" Search......."
              />
              <SearchIcon className="top-[8px] right-[8px] absolute newadd2" />
            </div>
          </div>

          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto">
            <table className="rounded-md w-full table-auto table-status">
              <thead
                onClick={toggleTable}
                className="set-shadow cursor-pointer"
              >
                {isLoading ? (
                  <TableHeaderSkeleton />
                ) : (
                  <tr>
                    <th className="flex justify-center items-center p-3 border-r font-medium text-center text-xs whitespace-nowrap">
                      <IoMdArrowDropright
                        className={`text-[20px] transition-transform duration-200 ${
                          isOpen5 ? "rotate-90 text-[black]" : "rotate-0"
                        }`}
                      />
                    </th>

                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Status Name
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Status Color
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Status Order
                    </th>
                    {/* <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">Status Default Filter</th> */}
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Status can be changed to
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Action
                    </th>
                  </tr>
                )}
              </thead>
              <tbody
                className={`transition-all duration-500 ease-in-out overflow-hidden ${
                  isOpen5 ? "max-h-screen" : "max-h-0"
                }`}
                style={{ display: isOpen5 ? "table-row-group" : "none" }}
              >
                {isLoading ? (
                  [...Array(10)].map((_, index) => (
                    <TableRowSkeleton key={index} />
                  ))
                ) : status && status?.length > 0 ? (
                  status?.map((item, index) => (
                    <tr key={item?.id} className="border">
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {index + 1}
                      </td>

                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.taskStatusName}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.statusColor}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.statusOrder}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.isHiddenFor
                          .map((item) => item?.User?.name)
                          .join(", ")}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        <div className="flex justify-center items-center gap-2">
                          <button
                            className=" "
                            onClick={() => {
                              setTaskData(item);
                            }}
                          >
                            <BorderColorIcon className="text-[#27004a]" />
                          </button>
                          <div>
                            <button
                              onClick={() => {
                                setOpen11(true);
                              }}
                            >
                              <DeleteIcon className="text-red-500 cursor-pointer" />
                            </button>
                            {open11 && (
                              <ConfirmationModal
                                setClose={onCloseModal11}
                                id={item?.id}
                                callback={deleteTaskStatus}
                              />
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="h-[100px]">
                    <td
                      colSpan="6"
                      className="py-4 font-semibold text-center text-red-500 text-sm"
                    >
                      Task Status Not Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        isOpen={taskData !== null}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal6}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="border-[#000] p-3 border-b text-[14px]"
        >
          Edit Task Status
        </h2>
        <button
          onClick={() => {
            setTaskData(null);
          }}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>

        <div className="first-panel">
          <div className="p-4 overflow-y-scroll">
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Name</label>
              <br />
              <input
                type="text"
                value={updateStatusName || ""}
                onChange={(e) => setUpdateStatusName(e.target.value)}
                placeholder=""
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Color</label>
              <br />
              <input
                type="color"
                value={updateStatusColor || ""}
                onChange={(e) => setUpdateStatusColor(e.target.value)}
                placeholder=""
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Order</label>
              <br />
              <input
                type="number"
                value={updateStatusOrder || ""}
                onChange={(e) => setUpdateStatusOrder(e.target.value)}
                placeholder=""
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
              />
            </div>
            <div className="mb-[26px] w-[100%] xl:[48%]">
              <label className="text-[14px]">is hidden for</label>
              <br />
              <Select
                isMulti
                name="updateIsHiddenFor"
                options={staffs?.map(({ staffDetails, name }) => ({
                  label: name,
                  value: staffDetails?.id,
                }))}
                className="basic-multi-select newsetup3"
                classNamePrefix="select"
                defaultValue={taskData?.isHiddenFor?.map((item) => ({
                  label: item?.User?.name,
                  value: item?.id,
                }))}
                onChange={(selectedOptions) =>
                  setUpdateIsHiddenFor(selectedOptions)
                }
                styles={customStyles}
              />
            </div>
            <div className="mb-[20px] w-[100%] xl:[48%]">
              <label className="text-[14px]">Can be changed to</label>
              <br />
              <Select
                isMulti
                name="updateCanBeChanged newsetup3"
                classNamePrefix="select"
                onChange={(e) => {
                  setUpdateCanBeChanged(e.map((item) => item?.value));
                }}
                defaultValue={taskData?.TaskStatus?.map((item) => ({
                  label: item?.taskStatusName,
                  value: item?.id,
                }))}
                options={
                  status
                    ? status.map((taskStatus, index) => {
                        return {
                          value: taskStatus?.id,
                          label: taskStatus?.taskStatusName,
                        };
                      })
                    : []
                }
                styles={customStyles}
              >
                {/* <option >Nothing Selected</option> */}
              </Select>
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button
              className="first-btn"
              onClick={() => {
                setTaskData(null);
              }}
            >
              Cancel
            </button>
            <button
              className={`${isLoading ? "second-btn-disabled" : "second-btn"}`}
              onClick={updateTaskStatus}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default Edit_Task_Status;
